<mat-progress-bar *ngIf="!isLoaded" fxFlex="100" mode="indeterminate"></mat-progress-bar>

<div *ngIf="isLoaded" fxFlex="100" fxLayout="row">
    <div fxFlex="35">
        <fund-recap-row [header]="true"></fund-recap-row>

        <mat-divider></mat-divider>

        <fund-recap-row *ngFor="let fund of funds" [fund]="fund">
        </fund-recap-row>
    </div>

    <div fxFlex="20">&nbsp;</div>

    <div fxFlex="40" fxLayout="column">
        <fund-total-chart [funds]="funds" [id]="id">
        </fund-total-chart>
    </div>
</div>
